import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed, inject } from 'vue';
import { CARD_TYPE } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    var formRef = inject('formRef');
    var onCardTypeChange = function () {
      var _a;
      if (formRef === null || formRef === void 0 ? void 0 : formRef.value) {
        (_a = formRef.value) === null || _a === void 0 ? void 0 : _a.validateFields(['cardNo']);
      }
    };
    return function (_ctx, _cache) {
      var _component_a_select = _resolveComponent("a-select");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfCardType.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "证件类型：",
            name: "cardType"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_select, {
                allowClear: "",
                size: "large",
                value: _unref(formState).cardType,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).cardType = $event;
                }),
                options: _unref(CARD_TYPE),
                placeholder: "证件类型",
                onChange: onCardTypeChange
              }, null, 8, ["value", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});